import React from "react";
import styled from "styled-components";

const ColumnBody = styled.div``;

const BuilderColumn = props => {
    const { className } = props;

    return (
        <ColumnBody className={"column-inner " + className}>
            {props.children}
        </ColumnBody>
    );
};

export default React.memo(BuilderColumn);
